import React, { useState } from 'react';
import { Form, Modal } from 'antd';
import { createRidePromotionService } from '../../../../services/admin/ridePromotionServices';
import formSetDynamicErrors from '../../../../utils/functions/formSetDynamicErrors';
import useTranslation from '../../../hooks/translation/useTranslation';
import RidePromotionForm from '../../forms/RidePromotionForm';

function AddRidePromotionModal({ show, setShow, refetchData }) {
  const { trans } = useTranslation();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleFinish = async (values) => {
    try {
      setIsLoading(true);
      await createRidePromotionService(values);
      form.resetFields();
      setShow(false);
      refetchData();
    } catch (e) {
      if (e?.response?.data?.errors) {
        formSetDynamicErrors({ e, form, trans });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={show}
      footer={null}
      onCancel={() => setShow(false)}
    >
      <h3 className="text-center">
        {trans('add')}
      </h3>
      <RidePromotionForm form={form} onFinish={handleFinish} isLoading={isLoading} />
    </Modal>
  );
}

export default AddRidePromotionModal;
